export type GameControlPhase =
  | 'key9_in_progress'
  | 'key9_practice'
  | 'key9_unlocked'
  | 'key9_missed'
  | 'key9_practice_complete'
  | 'full_in_progress'
  | 'full_done'
  | 'active';

export type GameControlAction = {
  id: 'undo' | 'erase' | 'notes' | 'hint';
  label: string;
  icon: string;
};

export type GameControlState = {
  visible: boolean;
  mode: 'hidden' | 'full';
  actions: GameControlAction[];
};

const FULL_ACTIONS: GameControlAction[] = [
  { id: 'undo', label: 'Undo', icon: '↶' },
  { id: 'erase', label: 'Erase', icon: '⌫' },
  { id: 'notes', label: 'Notes', icon: '✎' },
  { id: 'hint', label: 'Hint', icon: '?' }
];

export function getGameControlState(phase: GameControlPhase): GameControlState {
  if (phase === 'full_in_progress') {
    return {
      visible: true,
      mode: 'full',
      actions: FULL_ACTIONS
    };
  }

  return {
    visible: false,
    mode: 'hidden',
    actions: []
  };
}
